





















































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Getter, Action } from "vuex-class";

import Customer, { customerInitValue } from "@/types/customer/Customer";
import UserInterface from "@/types/app/IUser";
import CustomerService from "@/services/customerService";
import { getFileNameFromLink } from "@/utils/fileName";
import {
  ImportAccountHeader,
  ImportInterestHeader,
} from "@/components/headers/header-import";
import Header from "@/types/app/header";
import formatDate from "@/utils/formatDate";
import Endpoint from "@/utils/endpoint";
import * as XLSX from "xlsx";
import ModalSuccess from "@/components/common/ModalSuccess.vue";
import { CustomerSelectValue } from "@/utils/getCustomers";
import AccountService from "@/services/accountService";
import AccountInterface, { accountInitialValue } from "@/types/app/accounts";
import Interest from "@/types/app/excelData";
import ErrorService from "@/services/erroService";
import BaseComponent from "@/utils/baseComponent";

interface ProductFund {
  fundName: string;
  fundSiteName: string;
  fundId: string;
}

interface AccountImport {
  Email: string;
  AccountNumber: string;
  FundId: string;
  FundName: string;
  UserId: string;
  Error: string;
}

interface InterestImport {
  Id: string;
  Email: string;
  FirstName: string;
  LastName: string;
  Country: string;
  Phone: string;
  Error: string;
  Classification: string;
  TypePerson: string;
  Accounts: AccountImport[];
  Person: Person;
}

interface Person {
  classification: string;
  type: string;
  config: any[];
}

@Component({
  components: { ModalSuccess },
  data: () => ({
    isLCM: false,
    endpoint: new Endpoint(),
  }),
})
export default class ModalImportInterest extends BaseComponent {
  @Getter("getModalImportInterestState", { namespace: "customer" })
  modalImportInterestState!: boolean;
  @Getter("getActiveCustomers", { namespace: "customer" }) customersActive!: Customer[];
  @Getter("getCustomersAll", { namespace: "customer" }) customersAll!: Customer[];
  @Action("setModalImportInterestState", { namespace: "customer" })
  setModalImportInterestState!: any;
  height = "";
  customer: Customer = customerInitValue;
  @Getter("getUser", { namespace: "auth" }) user!: UserInterface;
  @Action("setCustomers", { namespace: "customer" }) setCustomers!: any;
  headersInterest: Header[] = ImportInterestHeader.header;
  headersAccount: Header[] = ImportAccountHeader.header;
  private accountService = new AccountService(this.$http);
  errorCreate = false;
  openSuccessModal = false;
  openSuccessModalMessage = "Imported interested and accounts with success!!";
  loading = false;
  getFileNameFromLink = getFileNameFromLink;
  formatDate = formatDate;
  isLCM = false;
  private endpoint = new Endpoint();
  interests = new Array<InterestImport>();
  valid = true;
  customerService = new CustomerService(this.$http);
  funds: ProductFund[] = [];
  customers: Customer[] = [];
  accounts: AccountInterface[] = [];
  errorMessage = "";
  validationMessage = "";
  headerInterest = [
    "Email",
    "FirstName",
    "LastName",
    "Country",
    "Phone",
    "Classification",
    "TypePerson",
  ];
  headerAccount = ["Email", "AccountNumber", "FundName"];

  async mounted() {
    this.loading = true;
    const [fundResponse, customerResponse, accountResponse] = await Promise.all([
      this.getProductFunds(),
      this.getCustomers(),
      this.accountService.getAccounts(),
    ]);
    this.funds = fundResponse;
    this.customers = customerResponse;
    this.accounts = accountResponse;
    this.loading = false;
  }

  clear() {
    this.interests = [];
    this.interestsErros = [];
    this.accountsErros = [];
    this.errorMessage = "";
    this.validationMessage = "";
    this.errorCreate = false;
  }

  closeModal(): void {
    this.setModalImportInterestState(false);
    this.clear();
  }
  interestsErros: InterestImport[] = [];
  getRowInterestClass(item: InterestImport) {
    if (item.Error && item.Accounts.some((a) => a.Error)) {
      return "invalid-row";
    }
  }

  validationImport() {
    this.interests.forEach((i) => {
      this.noValid(i);
      i.Accounts.forEach((a) => {
        const validAccounts = this.validationAccount(a);
        if (!validAccounts.valid) {
          a.Error = validAccounts.message;
          i.Error = i.Error ? i.Error + " Account error." : i.Error;
        }
      });
    });

    console.log("validationImport", this.interests);
  }

  accountsErros: AccountImport[] = [];
  getRowAccountClass(item: AccountImport) {
    if (item.Error) {
      return "invalid-row";
    }
  }

  getFundId(fundName: string): string | any {
    return this.funds.find(
      (x) =>
        x.fundName.toLocaleLowerCase() == fundName.toLocaleLowerCase() ||
        x.fundSiteName.toLocaleLowerCase() == fundName.toLocaleLowerCase()
    )?.fundId;
  }

  noValid(item: InterestImport) {
    let message = "";
    if (item.FirstName && item.FirstName.length > 0) {
      if (!item.Country) message += "Valid country is required. ";
      if (!item.LastName) message += "Valid last name is required. ";
      if (!item.Phone) message += "Valid phone number is required. ";
      if (!item.TypePerson) message += "Valid person Type is required. ";
      if (!this.noValidPerson(item))
        message += "Valid person Type or classification is required. ";
      const valid = this.validateEmail(item.Email);
      if (!valid.validEmail) message += valid.message;

      if (message.length > 0) {
        item.Error = message;
      }
    }
  }

  validationAccount(item: AccountImport) {
    const valid = { valid: true, message: "" };
    if (!item.FundId) {
      valid.message += "Fund name not found. ";
      valid.valid = false;
    }
    if (
      this.accounts.some(
        (x) =>
          x.accountNumber == item.AccountNumber &&
          x.fundId == item.FundId &&
          x.userId == item.UserId
      )
    ) {
      valid.message = `User ${item.Email} with account number ${item.AccountNumber} and fund name ${item.FundName} already exist. `;
      valid.valid = false;
    }
    return valid;
  }

  noValidPerson(item: InterestImport): boolean | any {
    const arrClassification = ["US", "NONUS", "ALL"];
    const arrTypePeron = [
      "AsNatural",
      "AsCorporate",
      "AsTrust",
      "ViaPlan",
      "NotAccredited",
    ];

    return (
      arrTypePeron.find((c) => c == item.TypePerson?.replace(/\s/g, "")?.toUpperCase()) ||
      arrClassification.find(
        (c) => c == item.Classification?.replace(/\s/g, "")?.toUpperCase()
      )
    );
  }

  validateEmail(email: string) {
    console.log(email);
    //eslint-disable-next-line
    const res = new RegExp(/^[\w\-\+\.]{1,}@([\w-]+\.)+[\w-]{2,}$/);
    const validEmail = res.test(email);
    let message = "";
    let notExists = false;
    if (validEmail) {
      const user = this.customersAll.find(
        (x) => x.email.toLocaleLowerCase().trim() == email.toLocaleLowerCase().trim()
      );
      console.log(user);
      notExists = user?.id == null;
      if (!notExists) {
        message = `Email already exists, current status is ${user?.statusDesc}. `;
      }
    } else message = "Email not valid. ";
    return { validEmail: validEmail && notExists, message };
  }

  handleFileImport() {
    // Trigger click on the FileInput
    (this.$refs.uploader as HTMLElement).click();
  }

  async save() {
    if (!this.form().validate()) {
      return false;
    }
    this.errorCreate = false;
    this.loading = true;

    try {
      const saveInterests = (this.interests.filter(
        (x) => x.FirstName && !x.Error
      ) as unknown) as Interest[];
      if (saveInterests.length > 0) {
        await this.saveInterests(saveInterests);
      }
      await this.saveAccounts();
    } finally {
      this.loading = false;
    }
  }

  existsAccounts(account: AccountImport): boolean {
    return this.accounts.some(
      (x) =>
        x.accountNumber == account.AccountNumber &&
        x.fundId == account.FundId &&
        x.userId == account.UserId
    );
  }

  loadCustomers() {
    this.setCustomers([]);
    this.$http
      .get(this.endpoint.customers)
      .then((resp) => {
        this.setCustomers(resp.data);
      })
      .catch((err) => {
        ErrorService.onError(err);
      });
  }

  async saveInterests(saveInterests: Interest[]) {
    try {
      const resp = await this.customerService.saveInterests(saveInterests);
      if (resp.hasError === false || resp.data?.length > 0) {
        this.interests.forEach((i) => {
          i.Accounts.forEach((a) => {
            a.UserId = (resp.data as any[]).find((x) => x.email == a.Email)?.id;
            i.Id = a.UserId;
          });
        });
      }
      if (resp.hasError) {
        this.errorMessage = resp.messageError.join("<br />");
        this.errorCreate = true;
        this.loading = false;
      }
    } catch (ex) {
      ErrorService.onError(ex);
      this.errorCreate = true;
      this.loading = false;
    }
  }

  async saveAccounts() {
    const accountsData: AccountInterface[] = [];
    this.interests.forEach((x) => {
      x.Accounts.forEach((a) => {
        if (!a.Error) accountsData.push((a as any) as AccountInterface);
      });
    });
    const success = await this.accountService.saveAccounts(accountsData);

    if (success) {
      const newInterestsErros = this.interests
        .filter((x) => x.Error)
        .map(({ Person, Accounts, ...rest }) => {
          return rest;
        });
      this.loadCustomers();
      const newAccountErrors: any[] = [];
      this.interests.forEach((i) => {
        if (i.Accounts.length > 0) {
          i.Accounts.forEach((a) => {
            if (a.Error) {
              const { UserId, FundId, ...rest } = a;
              newAccountErrors.push(rest);
            }
          });
        }
      });
      if (newAccountErrors.length > 0 || newInterestsErros.length > 0) {
        this.openSuccessModalMessage =
          "Import Interests and Accounts with any erros in file";

        this.download(newInterestsErros, newAccountErrors);
      }

      this.openSuccessModal = true;

      this.closeModal();
      this.loading = false;
    } else {
      this.errorCreate = true;
      this.loading = false;
    }
  }

  async getProductFunds(): Promise<ProductFund[]> {
    const url = this.endpoint.productFund;
    const response = await this.$http.get(`${url}?hasInvestment=false`);

    const productFunds = response.data as ProductFund[];

    return productFunds;
  }

  async getCustomers(): Promise<Customer[]> {
    const customerOrdened = [...this.customersActive];

    return customerOrdened;
  }

  async showMessageError(message: string) {
    this.showError(message);
  }

  importData(event: any) {
    const file = event.target.files ? event.target.files[0] : null;
    if (file) {
      this.clear();
      this.loading = true;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        /* Parse data */
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        /* Convert array of arrays */
        this.interests = XLSX.utils.sheet_to_json<InterestImport>(
          wb.Sheets[wb.SheetNames[0]],
          {
            blankrows: false,
          }
        );

        /* Convert array of arrays */
        const accounts = XLSX.utils.sheet_to_json<AccountImport>(
          wb.Sheets[wb.SheetNames[1]],
          {
            blankrows: false,
          }
        );

        let myArray: any[] = [];
        const unique: InterestImport[] = [];

        const noUsers = accounts.filter(
          (x) =>
            this.interests.findIndex(
              (i) =>
                i.Email.trim().toLocaleLowerCase() == x.Email.trim().toLocaleLowerCase()
            ) == -1
        );

        noUsers.forEach((x) => this.interests.push({ Email: x.Email } as InterestImport));

        this.interests.map((x) =>
          unique.filter(
            (a) =>
              a.Email?.trim()?.toLocaleLowerCase() == x.Email?.trim()?.toLocaleLowerCase()
          ).length > 0
            ? null
            : unique.push(x)
        );
        this.interests = unique;

        // Add all the found data columns to the workflow data
        this.interests.forEach((x) => {
          if (x.FirstName) {
            if (!x.Phone) x.Phone = "11 111111111";
            x.Email = x.Email?.trim().toLocaleLowerCase();
            x.FirstName = x.FirstName?.trim().toLocaleLowerCase();
            x.LastName = x.LastName?.trim().toLocaleLowerCase();
            x.TypePerson = this.changeTypePerson(x.TypePerson);
            x.Person = {
              classification: x.Classification?.replace(/\s/g, ""),
              type: x.TypePerson,
              config: [{ text: "Text 1", selected: "true" }],
            };
          }
          accounts.forEach((a) => {
            if (
              a.Email.trim().toLocaleLowerCase() == x.Email.trim().toLocaleLowerCase()
            ) {
              a.UserId = this.customersActive.find(
                (c) =>
                  c.email.trim().toLocaleLowerCase() == a.Email.trim().toLocaleLowerCase()
              )?.id as string;
              a.FundId = this.getFundId(a.FundName);
              myArray.push(a);
            }
          });
          x.Accounts = myArray;
          myArray = [];
        });
        this.validationImport();
        this.loading = false;
      };

      reader.readAsBinaryString(file);
    }
  }

  changeTypePerson(typePerson: string): string {
    switch (typePerson) {
      case "As a Natural Person":
        return "AsNatural";
      case "As a Corporate, Foundation, Endowment, Company or LLC":
        return "AsCorporate";
      case "As a Trust, Bank, Savings and Loan (or similar Institution) or Insurance Company":
        return "AsTrust";
      case "Via an Employee Benefit Plan, Individual Retirement Account, or Keogh Plan":
        return "ViaPlan";
      case "I am NOT an Accredited Investor":
        return "NotAccredited";
      default:
        return typePerson;
    }
  }

  download(interests: any[], accounts: any[]) {
    const nameTemplate =
      interests.length > 0 || accounts.length > 0 ? "import_errors_" : "template_export_";
    const dataInterestJson = XLSX.utils.json_to_sheet(interests, {
      header: this.headerInterest,
    });
    const dataAccountJson = XLSX.utils.json_to_sheet(accounts, {
      header: this.headerAccount,
    });
    const wbInterest = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wbInterest, dataInterestJson, "BulkUsers");
    XLSX.utils.book_append_sheet(wbInterest, dataAccountJson, "BulkAccounts");
    XLSX.writeFile(wbInterest, nameTemplate + new Date().getTime() + ".xlsx");
  }
}
